export const returnEmptyIfNull = value => {
	return value ? value : "";
};
